/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Sports_Nutrition_TermsInputs */

const en_service_type_sports_nutrition_terms = /** @type {(inputs: Service_Type_Sports_Nutrition_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sports dietitian, athlete diet, bulking, cutting, supplements`)
};

const pl_service_type_sports_nutrition_terms = /** @type {(inputs: Service_Type_Sports_Nutrition_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dieta sportowca, dieta na masę, dieta na redukcję, suplementacja, dietetyk sportowy`)
};

/**
* | output |
* | --- |
* | "sports dietitian, athlete diet, bulking, cutting, supplements" |
*
* @param {Service_Type_Sports_Nutrition_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_sports_nutrition_terms = /** @type {((inputs?: Service_Type_Sports_Nutrition_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Sports_Nutrition_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_sports_nutrition_terms(inputs)
	return en_service_type_sports_nutrition_terms(inputs)
});